import type { SVGProps } from 'react';

/** Two keys — matches the Multisigs empty-state mark (`KeysFilledIcon`). */
export function KeysIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M16.85 11.7a6.15 6.15 0 0 1 0 12.3 6.15 6.15 0 0 1-5.457-3.315h-.597c-.553 0-1.083-.22-1.474-.612l-.096-.096a.293.293 0 0 0-.414 0l-.561.561a1.293 1.293 0 0 1-1.828 0l-.56-.56a.293.293 0 0 0-.415 0l-.56.56a1.294 1.294 0 0 1-1.828 0l-1.681-1.682a1.293 1.293 0 0 1 0-1.828l1.217-1.217c.39-.391.921-.61 1.474-.61h7.23a6.15 6.15 0 0 1 5.55-3.5m1.65 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M7.15 0a6.15 6.15 0 0 1 5.55 3.5h7.23c.553 0 1.083.22 1.474.61l1.217 1.218a1.293 1.293 0 0 1 0 1.828l-1.68 1.682a1.293 1.293 0 0 1-1.829 0l-.56-.56a.294.294 0 0 0-.414 0l-.56.56a1.293 1.293 0 0 1-1.829 0l-.56-.56a.293.293 0 0 0-.415 0l-.096.095c-.391.39-.921.611-1.474.611h-.597A6.15 6.15 0 1 1 7.15 0M5.5 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
        clipRule="evenodd"
      />
    </svg>
  );
}
